export const CompanyExists: string = 'COMPANY_EXISTS';
export const UserExists: string = 'USER_EXISTS';
export const InvalidToken: string = 'INVALID_TOKEN';
export const BreachedPassword: string = 'BREACHED_PASSWORD';
export const InvalidPassword: string = 'INVALID_PASSWORD';
export const DoorModelExists: string = 'DOOR_MODEL_EXISTS';
export const DoorModelUsed: string = 'DOOR_MODEL_USED';
